export const QUESTION_TYPE_SINGLESELECT = 'SingleSelect'
export const QUESTION_TYPE_MULTISELECT = 'MultiSelect'
export const QUESTION_TYPE_NEEDS = 'Needs'
export const QUESTION_TYPE_LETSGO = 'LetsGo'